import React, { useContext } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CardMedia,
  IconButton,
} from "@mui/material";
import { CartContext } from "../context/CartContext";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { setCheckout } from "../utils/buyNowStorage";

const CartPage = () => {
  const { cart, updateQty, removeItem } = useContext(CartContext);
  const navigate = useNavigate();

  if (cart.length === 0)
    return (
      <Typography sx={{ textAlign: "center", mt: 4 }}>
        Cart is empty
      </Typography>
    );
  const total = cart.reduce((s, i) => s + i.price * i.qty, 0);
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Your Cart
      </Typography>
      {cart.map((item) => (
        <Card key={item.id} sx={{ display: "flex", mb: 2, p: 1 }}>
          <CardMedia
            component="img"
            sx={{ width: 140, borderRadius: 2 }}
            image={item.imageUrl.thumbnailUrl}
          />

          <CardContent sx={{ flex: 1 }}>
            <Typography fontWeight={600}>{item.title}</Typography>
            <Typography>₹{Number(item.price || 0).toLocaleString("en-IN")}</Typography>

            <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
              <Button
                variant="outlined"
                onClick={() => updateQty(item.id, item.qty - 1)}
              >
                -
              </Button>
              <Typography>{item.qty}</Typography>
              <Button
                variant="outlined"
                onClick={() => updateQty(item.id, item.qty + 1)}
              >
                +
              </Button>
            </Box>
          </CardContent>

          <IconButton onClick={() => removeItem(item.id)} color="error">
            <DeleteIcon />
          </IconButton>
        </Card>
      ))}

      <Typography variant="h6" sx={{ mt: 2 }}>
        Total: ₹{Number(total).toLocaleString("en-IN")}
      </Typography>

      <Button
        variant="contained"
        sx={{ mt: 2, background: "#ff9900" }}
        onClick={() => {
          setCheckout({
            mode: "CART",
            items: cart.map((i) => ({ ...i })), // ✅ clone
          });
          navigate("/delivery-location");
        }}
      >
        Checkout →
      </Button>
    </Box>
  );
};

export default CartPage;